import { render, staticRenderFns } from "./DocumentPortalSidebar.vue?vue&type=template&id=509c3227&scoped=true&"
import script from "./DocumentPortalSidebar.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalSidebar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalSidebar.vue?vue&type=style&index=0&id=509c3227&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509c3227",
  null
  
)

export default component.exports